import { api } from "@/lib/api/client";
import type { Session, TokenPair } from "@/lib/api/types";

export interface RegisterInput {
  email: string;
  password: string;
  full_name_en: string;
}

export const authApi = {
  register: (input: RegisterInput) => api.post<TokenPair>("/auth/register", input),
  session: () => api.get<Session>("/auth/session"),
  forgotPassword: (email: string) =>
    api.post<{ message: string }>("/auth/forgot-password", { email }),
  resetPassword: (token: string, password: string) =>
    api.post<{ message: string }>("/auth/reset-password", { token, password }),
  changePassword: (current_password: string, new_password: string) =>
    api.post<{ message: string }>("/auth/change-password", { current_password, new_password }),
};
